<template>
  <div class="cooperation-block-cp-wrap">
    <div class="cooperation-block-cp-container" style="flex:1">
      <div class="section">{{ data.contractSum }}</div>
      <div class="footer">合同数量</div>
    </div>
    <div class="cooperation-block-cp-container" style="flex:2">
      <div class="section">{{ data.adYdyjconfirmAmount | money2 }}</div>
      <div class="footer">累计一单一结确认金额</div>
    </div>
    <div class="cooperation-block-cp-container" style="flex:1.5">
      <div class="section" style="color:#36C490">
        {{ data.contractSignsum | money2 }}
      </div>
      <div class="footer">合同签约总额</div>
    </div>
  </div>
</template>

<script>
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-block-cp',

  data() {
    return {
      data: {}
    };
  },
  mounted() {},

  created() {
    let { providerGuid } = getUrlParams();

    let params = {
      providerGuid
    };
    this.getContracStaistics(params);
  },
  methods: {
    getUrlParams() {
      let url = window.location.href.split('?')[1];
      let obj = {};
      if (url.indexOf('&') > -1) {
        url = url.split('&');
        for (let i = 0; i < url.length; i++) {
          let arr = url[i].split('=');
          obj[arr[0]] = arr[1];
        }
      } else {
        url = url.split('=');
        obj[url[0]] = url[1];
      }
      return obj;
    },
    getContracStaistics(params) {
      this.$api.getContracStaistics(params).then(res => {
        let { status, body } = res;
        if (status) {
          this.data = body;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-block-cp-wrap {
  display: flex;
  // background: #fff;
  background: transparent;
}
.cooperation-block-cp-container {
  flex: auto;
  text-align: center;
  padding: 32px 0px;
  position: relative;
  .head {
    color: #36c392;
    font-size: 25px;
    font-weight: bold;
    padding-top: 12px;
  }
  .section {
    color: #000000;
    font-size: 32px;
    font-weight: bold;
    padding-top: 12px;
    // border-right: 1px solid #efefef;
  }
  .section:last-child {
    border-right: none;
  }
  .footer {
    color: #666666;
    padding-top: 12px;
    font-size: 24px;
    font-weight: 400;
  }
}
.cooperation-block-cp-container::after {
  position: absolute;
  content: '';
  border: 1px solid #efefef;
  right: 0px;
  height: 52px;
  top: 60px;
  transform: scaleX(0.5);
}
.cooperation-block-cp-container:last-child::after {
  border: none;
}
</style>
